// @flow
import createRestApiClient from "../../utility/createRestApiClient";

import {
  IDLE,
  IN_PROGRESS,
  SUCCESS,
  FAILED
} from "../../common/constants/Auth";
import {
  // AUTH_LOADING,
  // AUTH_SUCCESS,
  AUTH_FAILED,
  // AUTH_CLEAR,
  AUTH_IN_PROGRESS,
  AUTH_BLANK_STATE,
  SET_AUTH,
  VERIFY_AUTH,
  TOKEN_LOADING,
  TOKEN_SUCCESS,
  TOKEN_FAILED
} from "../actionTypeConstants/Auth";
import { getUrlByUserDomain } from "../../utility/utilityFunctions";

const mockApiClient = createRestApiClient().withConfig({
  baseURL: getUrlByUserDomain(
    process.env.REACT_APP_USER_INFO_URL_PREFIX ||
      window?._env_?.REACT_APP_USER_INFO_URL_PREFIX
  )
}).client;
let token_global = null;
let payload_global = null;

const initialState = {
  status: IDLE,
  token: null,
  payload: {},
  authorize: false,
  authenticate: false,
  accessKeyData: {},
  jenkins: false,
  jenkins_payload: {
    status: IDLE,
    token: null,
    username: null
  }
};

type State = {
  status: String,
  token: String | null,
  payload: Object | null,
  authorize: Boolean,
  authenticate: Boolean,
  accessKeyData: Object
};
export default (state: State = initialState, action) => {
  switch (action.type) {
    case AUTH_IN_PROGRESS:
      return {
        ...state,
        status: IN_PROGRESS,
        token: null,
        payload: {},
        authenticate: false,
        authorize: false,
        logout: false,
        accessKeyData: {},
        jenkins: false
      };

    case SET_AUTH:
      return {
        ...state,
        status: SUCCESS,
        token: action.token,
        payload: action.payload,
        authenticate: action.authenticate,
        authorize: action.authorize,
        logout: false,
        accessKeyData: {},
        jenkins: false
      };
    case VERIFY_AUTH:
      return {
        ...state,
        status: SUCCESS,
        token: token_global,
        payload: payload_global,
        authenticate: true,
        authorize: true,
        logout: false,
        accessKeyData: action.result.data,
        jenkins: false
      };

    case AUTH_FAILED:
      return {
        ...state,
        status: FAILED,
        token: null,
        payload: {},
        authenticate: false,
        authorize: false,
        logout: false,
        accessKeyData: {},
        jenkins: false
      };

    case TOKEN_LOADING:
      return {
        ...state,
        status: IN_PROGRESS,
        token: null,
        payload: {},
        authenticate: false,
        authorize: false,
        logout: false,
        accessKeyData: {},
        jenkins: false
      };
    case TOKEN_SUCCESS:
      return {
        ...state,
        status: SUCCESS,
        token: null,
        payload: {},
        authenticate: true,
        authorize: true,
        logout: false,
        accessKeyData: action.result.data,
        jenkins: true
      };
    case TOKEN_FAILED:
      return {
        ...state,
        status: FAILED,
        token: null,
        payload: {},
        authenticate: false,
        authorize: false,
        logout: false,
        accessKeyData: {},
        jenkins: false
      };

    case AUTH_BLANK_STATE:
      return initialState;

    default:
      return state;
  }
};

export const resetState = () => (dispatch: Dispatch) => {
  dispatch({
    type: AUTH_BLANK_STATE,
    token: null,
    payload: null,
    authenticate: false,
    authorize: false,
    logout: false,
    accessKeyData: {}
  });
};

export const logout = () => {
  return {
    type: AUTH_BLANK_STATE,
    token: null,
    payload: null,
    authenticate: false,
    authorize: false,
    logout: true,
    accessKeyData: {}
  };
};

export const authorize = (token, payload) => (dispatch: Dispatch) => {
  token_global = token;
  payload_global = token;
  dispatch({
    type: SET_AUTH,
    token: token,
    payload: payload,
    authenticate: false,
    authorize: true,
    logout: false,
    accessKeyData: {}
  });
};

export function fetchAccessKey(token) {
  const headers = {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  return {
    types: [AUTH_IN_PROGRESS, VERIFY_AUTH, AUTH_BLANK_STATE],
    promise: () =>
      mockApiClient.get(`/api/user/token`, {
        headers: headers
      })
  };
}
export function verifyPluginAuth(token, username) {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  return {
    types: [TOKEN_LOADING, TOKEN_SUCCESS, TOKEN_FAILED],
    promise: () =>
      mockApiClient.post(
        `/api/user/token/auth`,
        {
          username: username,
          token: token
        },
        {
          headers: headers
        }
      )
  };
}
